import { useEffect } from "react";

interface SEOOptions {
  title: string;
  description?: string;
  keywords?: string;
}

const setMeta = (name: string, content: string, attr: "name" | "property" = "name") => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const useSEO = ({ title, description, keywords }: SEOOptions) => {
  useEffect(() => {
    document.title = title;
    setMeta("og:title", title, "property");
    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, "property");
    }
    if (keywords) {
      setMeta("keywords", keywords);
    }
  }, [title, description, keywords]);
};

export const SEO_HOME = {
  title: "粉色视频 - 专业视频内容聚合平台",
  description:
    "粉色视频为用户提供丰富多样的视频内容，涵盖电影、电视剧、综艺等多个类别，支持视频查找和观看，满足您的多元化视觉需求。",
  keywords: "粉色视频,视频平台,在线视频,影视视频,视频资源,视频内容,视频聚合",
};